<!--
 @description view选择图表类型
 @author huangzhijie
 @date 2018/11/1
-->
<style>
.view-select__cnt {
  box-sizing: border-box;
  margin-right: 24px;
  padding-top: 20px;
  width: 140px;
  height: 140px;
  text-align: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.85);
  background: #f6f6f6;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
}
.view-select__cnt:hover {
  border-color: #40A9FF;
  background-color: #FFF;
}
.view-select__cnt .view-select__icon-wrap {
  font-size: 64px;
  transition: transform .25s;
}

.view-select__cnt:hover .view-select__icon-wrap {
  transform: scale(1.2, 1.2);
}
</style>
<template>
  <div>
    <back :history="history"></back>
    <div class="view-chart-select">
      <div class="view-select__cnt ilb"
        v-bind:key="item.type"
        v-for="item in iconList"
        @click="e_click(item.type)">
        <div class="view-select__icon-wrap">
          <i class="icon" :class="item.iconClass"></i>
        </div>
        <div class="view-select__title el-font--base" v-text="item.name"></div>
      </div>
    </div>
  </div>
</template>

<script>
import back from '@/components/back.vue'
export default {
  data () {
    const that = this
    return {
      history: [
        { name: that.$t('view.config') },
        { name: that.$t('view.selectChart') }
      ],
      iconList: []
    }
  },
  components: {
    back
  },
  methods: {
    init () {
      const iconList = [
        { iconClass: 'icon-chartArea', name: this.$t('view.chartArea'), type: 'Area' },
        { iconClass: 'icon-chartLine', name: this.$t('view.chartLine'), type: 'Line' }
        // { iconClass: 'icon-chartHistogram', name: this.$t('view.chartHistogram'), type: 'Histogram' },
        // { iconClass: 'icon-chartPie', name: this.$t('view.chartPie'), type: 'Pie' }
        // { iconClass: 'icon-table', name: this.$t('view.tableTable'), type: 'Table' } TODO 表格没有实现
      ]
      this.iconList = iconList
    },
    e_click (type) {
      this.$router.push({
        name: 'viewDataSelect',
        query: {
          type: type
        }
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>